import { useId } from "react";

/**
 * MUI labels the panel region from the summary's own `id` and `aria-controls` (`Accordion.js`), and
 * generates neither — without both, the region has no name and no id for the header to point at.
 */
export const useAccordion = () => {
  const id = useId();

  return {
    headerId: `${id}-header`,
    panelId: `${id}-panel`,
  };
};
